export const isDarkModeActive = () => {
    const isOn = localStorage.getItem('darkModeOn')

    return isOn === '1'
}

export const toggleDarkMode = (isOn: boolean) => {
    localStorage.setItem('darkModeOn', isOn ? '1' : '0')
}
